export const IT_TICKET_URL =
  'https://cae.service-now.com/esc?id=sc_cat_item&sys_id=44e58650473752509c4bd8ca216d43c3';

export const COMMON_TICKET_URL =
  'https://cae.service-now.com/esc?id=sc_cat_item&sys_id=e77a3d484737de109c4bd8ca216d4333';
